import React, { useCallback, useEffect, useState } from 'react';
import Contenido from '../../../layout/Contenido';
import { useSelector } from 'react-redux';
import { blue } from '@material-ui/core/colors';
import { DataGrid } from '@material-ui/data-grid';
import { esProductoCrossSelling, getPedidosIncompletos } from '../../../utils';
import ListPdfDownloadButton from '../../botones/ListPdfDownloadButton';
import moment from 'moment';
import { getProductsPlacementsApi } from '../../../api/common.services';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export default function CrossSelling() {
	const { user } = useSelector((content) => content.User);
	const { pedidos } = useSelector((content) => content.Pedidos);
	const [crossSellingProducts, setCrossSellingProducts] = useState([]);

	const getCrossSellingProducts = useCallback(() => {
		const pedidosIncompletos = getPedidosIncompletos(pedidos);
		const productosCrossSelling = {};
		pedidosIncompletos.forEach((pedido) => {
			pedido.DETAILS.forEach((producto) => {
				if (esProductoCrossSelling(producto)) {
					const { PRODUCT_ID, DESCRIPTION, INCOMPLETE_AMOUNT } = producto;
					productosCrossSelling[PRODUCT_ID] = {
						id: PRODUCT_ID,
						PRODUCT_ID,
						name: DESCRIPTION,
						amount:
							INCOMPLETE_AMOUNT +
							(productosCrossSelling[PRODUCT_ID]?.amount || 0),
					};
				}
			});
		});
		return Object.values(productosCrossSelling);
	}, [pedidos]);

	useEffect(() => {
		if (pedidos.length === 0) {
			setCrossSellingProducts([]);
		} else {
			const products = getCrossSellingProducts();
			getProductsPlacementsApi({
				productIds: products.map((p) => p.id),
				codAlmacen: user.equipo === 'PERFUMERIA' ? '14' : '1',
			}).then(({ data }) => {
				const productPlacements = data;
				products.forEach((product) => {
					product.placement = productPlacements[product.id] || '';
				});
				setCrossSellingProducts([...products]);
			});
		}
	}, [pedidos, getCrossSellingProducts, user.equipo]);

	const columns = [
		{
			sortable: false,
			field: 'PRODUCT_ID',
			headerName: 'Código',
			width: 100,
		},
		{
			sortable: false,
			field: 'name',
			headerName: 'Producto',
			flex: 1,
		},
		{
			sortable: false,
			field: 'amount',
			headerName: '#',
			width: 50,
			renderCell: ({ value: amount }) => 'x' + amount,
		},
		{
			sortable: false,
			field: 'placement',
			headerName: 'Ubicacion',
			width: 300,
			renderCell: ({ value }) => {
				return <List dense style={{ display: 'flex' }} >
					{ value.map(ubicacion => (
						<ListItem>
							<ListItemText
								primary={ubicacion.store}
								secondary={ubicacion.position}
							/>
						</ListItem>
					))}
				</List>
			},
		},
	];

	const productsToPdfMapper = (data) => {
		return data.map((product) => [
			product.id,
			product.name,
			product.amount,
			product.placement[0] ? `${product.placement[0].store}: ${product.placement[0].position}` : '',
			product.placement[1] ? `${product.placement[1].store}: ${product.placement[1].position}` : ''
		]);
	};

	return (
		<Contenido
			title='Cross Selling'
			color={blue[700]}
			acciones={
				<ListPdfDownloadButton
					titulo={'Crosselling Products'}
					subtitulo={moment().format('DD-MM-YYYY HH:mm')}
					cabeceras={['Código', 'Producto', 'Cantidad', 'Ubicacion', '']}
					datos={productsToPdfMapper(crossSellingProducts)}
				/>
			}>
			<div
				style={{
					height: '100%',
					width: '100%',
				}}>
				<DataGrid
					rows={crossSellingProducts}
					columns={columns}
					pageSize={100}
					disableColumnMenu
					disableSelectionOnClick
					// rowHeight={100}
				/>
			</div>
		</Contenido>
	);
}
